module.exports = __webpack_public_path__ + "static/img/df7250f3809139d94f976937b9317779.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wk_white.png
// module id = SLPE
// module chunks = 1